const messages = {
  continue: 'Continue',
  about: 'About',
}

export default messages
